import { CommonModule, DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { CoreModule, PrintHook } from '@angular/flex-layout';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { ChildActivationEnd, Router, RouterModule } from '@angular/router';
import { LoginService } from '@core/services/login.service';
import { PreloaderService } from '@core/services/preloader.service';
import { environment } from '@env/environment';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { CookieService } from 'ngx-cookie-service';
import { CacheService } from './dp-world/services/cache.service';
import { GoogleAnalyticalService } from './dp-world/services/google-analytics.service';
import { StaticDataRemoteService } from './dp-world/services/static-data-remote.service';
import { UiService } from './dp-world/services/ui.service';
import { UtilsService } from './dp-world/services/utils.service';
import { MaterialModule } from './material.module';
import { AuthGuard } from './routes/sessions/login/auth.guard';
import { AuthService } from './routes/sessions/login/auth.service';
import { BasicAuthInterceptor } from './routes/sessions/login/basic-auth.interceptor';
import { GlobalTrimService } from './dp-world/services/global-trim.service';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [
        CommonModule,
        CoreModule,
        MaterialModule,
        HttpClientModule,
        RouterModule,
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        AuthService,
        AuthGuard,
        CookieService,
        { provide: 'googleTagManagerId', useValue: environment.enableGTAGID ? (environment.environmentName === 'Prod' ? environment.GTAG_ID : environment.GTAG_ID_NON_PROD) : 'DUMMY' },
        GoogleTagManagerService,
        DatePipe,
        UiService,
        UtilsService,
        LoginService,
        CacheService,
        StaticDataRemoteService
    ],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {

    loginIsInProgress = false;

    constructor(
        private preloader: PreloaderService,
        private readonly printHook: PrintHook,
        public authService: AuthService,
        private utils: UtilsService,
        private router: Router,
        private gtmService: GoogleAnalyticalService,
        private globalTrimService: GlobalTrimService) {
        const printHookPvt = this.printHook as any;
        const pagePrintBinder = printHookPvt.collectActivations;
        if (pagePrintBinder) {
            printHookPvt.collectActivations = (event) => {
                if (!printHookPvt.isPrintingBeforeAfterEvent) {
                    pagePrintBinder.bind(printHookPvt, event)();
                }
            };
        }
        this.authService.loginProgress.subscribe((event) => {
            this.loginIsInProgress = event ? true: false;
        });
    }

    ngOnInit() {
        this.routeInfo();
        this.utils.attachWindowResizeEvent();
        this.globalTrimService.initialize();
        if (window.location.href?.includes('/lending')) {
            const redirectParams = {
                returnUrl: window.location.pathname + window.location.search
            };
            this.authService.setLendingLoginUrl(JSON.stringify(redirectParams));
        }
    }

    ngAfterViewInit() {
        if (this.authService.currentUserValue) {
            this.preloader.hide();
        }
    }

    routeInfo(): void {
        let gtmTag;
        this.router.events.subscribe((event: any) => {
            if (event instanceof ChildActivationEnd) {
                if (event.snapshot.routeConfig && event.snapshot.routeConfig.path) {
                    gtmTag = {
                        event: event.snapshot.routeConfig.path,
                        pageName: event.snapshot.routeConfig.path
                    };
                } else {
                    const routeState = '_routerState';
                    gtmTag = {
                        event: (event.snapshot[routeState].url).replace('/', ''),
                        pageName: (event.snapshot[routeState].url).replace('/', '')
                    };
                }
                this.gtmService.pushTag(gtmTag);
            }
        });
    }
}
